import { memo } from 'react'

import { SVGProps } from './types/iconType'

export const CloseIcon = memo(({ className, style }: SVGProps) => {
  return (
    <svg style={style} className={className} viewBox="0 0 35 34" xmlns="http://www.w3.org/2000/svg">
      <g filter="url(#filter0_d_923_624)">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M26.3398 0.487964C29.7877 0.871959 32.5717 3.58392 32.977 7.04521C33.6743 12.9946 33.6743 19.005 32.977 24.9543C32.5717 28.4156 29.7877 31.1276 26.3398 31.5116C20.4644 32.1617 14.5353 32.1617 8.65998 31.5116C5.21202 31.1276 2.42806 28.4156 2.02273 24.9543C1.32576 19.005 1.32576 12.9946 2.02273 7.04521C2.42806 3.58392 5.21202 0.871959 8.65998 0.487964C14.5353 -0.162329 20.4644 -0.162329 26.3398 0.487964V0.487964ZM8.97464 3.29726C6.81467 3.53726 5.08536 5.2399 4.83336 7.37321C4.16188 13.1046 4.16188 18.8949 4.83336 24.6263C5.08402 26.7596 6.81333 28.4609 8.97331 28.7023C14.5919 29.3289 20.4052 29.3289 26.0238 28.7023C28.1837 28.4623 29.913 26.7596 30.1637 24.6263C30.8344 18.8948 30.8344 13.1047 30.1637 7.37321C29.913 5.2399 28.1837 3.53859 26.0238 3.29726C20.3576 2.67031 14.6395 2.67031 8.97331 3.29726H8.97464ZM12.8386 9.34652L17.4999 13.9998L22.1611 9.34652C22.4269 9.08125 22.787 8.93227 23.1625 8.93227C23.5379 8.93227 23.8981 9.08125 24.1638 9.34652C24.2954 9.47769 24.3998 9.63354 24.471 9.80514C24.5422 9.97674 24.5789 10.1607 24.5789 10.3465C24.5789 10.5323 24.5422 10.7163 24.471 10.8879C24.3998 11.0595 24.2954 11.2153 24.1638 11.3465L19.5025 15.9998L24.1638 20.653C24.2954 20.7842 24.3998 20.9401 24.471 21.1117C24.5422 21.2833 24.5789 21.4672 24.5789 21.653C24.5789 21.8388 24.5422 22.0228 24.471 22.1944C24.3998 22.366 24.2954 22.5218 24.1638 22.653C23.8981 22.9183 23.5379 23.0673 23.1625 23.0673C22.787 23.0673 22.4269 22.9183 22.1611 22.653L17.4999 17.9997L12.8386 22.653C12.5729 22.9183 12.2127 23.0673 11.8373 23.0673C11.4618 23.0673 11.1017 22.9183 10.8359 22.653C10.7044 22.5218 10.6 22.366 10.5287 22.1944C10.4575 22.0228 10.4208 21.8388 10.4208 21.653C10.4208 21.4672 10.4575 21.2833 10.5287 21.1117C10.6 20.9401 10.7044 20.7842 10.8359 20.653L15.4972 15.9998L10.8359 11.3465C10.7044 11.2153 10.6 11.0595 10.5287 10.8879C10.4575 10.7163 10.4208 10.5323 10.4208 10.3465C10.4208 10.1607 10.4575 9.97674 10.5287 9.80514C10.6 9.63354 10.7044 9.47769 10.8359 9.34652C11.1017 9.08125 11.4618 8.93227 11.8373 8.93227C12.2127 8.93227 12.5729 9.08125 12.8386 9.34652V9.34652Z"
        />
      </g>
      <defs>
        <filter
          id="filter0_d_923_624"
          x="0.5"
          y="0.000244141"
          width="34"
          height="33.999"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy="1" />
          <feGaussianBlur stdDeviation="0.5" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0" />
          <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_923_624" />
          <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_923_624" result="shape" />
        </filter>
      </defs>
    </svg>
  )
})
